"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TooltipPanel = _react.default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      inverted = _ref.inverted,
      active = _ref.active,
      error = _ref.error,
      props = _objectWithoutProperties(_ref, ["children", "inverted", "active", "error"]);

  var tooltipStyles = 'co-tooltip';
  var allowedModifiers = {
    active: active,
    error: error,
    inverted: inverted
  };
  var windowStyles = {
    left: "".concat(props.windowPosition.left, "px"),
    top: "".concat(props.windowPosition.top, "px"),
    transform: props.windowPosition.transform
  };
  return _react.default.createElement(_styler.default, {
    classNames: tooltipStyles,
    modifiers: allowedModifiers
  }, function (styles) {
    return _react.default.createElement("div", _extends({
      ref: ref,
      className: styles
    }, (0, _getNativeProps.default)(props), {
      style: _objectSpread({}, windowStyles)
    }), children);
  });
});

var mutuallyExclusiveStyles = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('inverted', 'error');
TooltipPanel.propTypes = {
  children: _propTypes.any.isRequired,
  active: _propTypes.bool,
  inverted: mutuallyExclusiveStyles,
  error: mutuallyExclusiveStyles
};
var _default = TooltipPanel;
exports.default = _default;
TooltipPanel.__docgenInfo = {
  "description": "",
  "methods": [],
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": ""
    },
    "active": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "inverted": {
      "type": {
        "name": "custom",
        "raw": "mutuallyExclusiveStyles"
      },
      "required": false,
      "description": ""
    },
    "error": {
      "type": {
        "name": "custom",
        "raw": "mutuallyExclusiveStyles"
      },
      "required": false,
      "description": ""
    }
  }
};